module.exports = __webpack_public_path__ + "static/media/man_jiyixiang.18038c37.png";